<template>
  <div class="phone-auth">
    <md-card md-with-hover class="home-card">
      <md-card-header>
        <!-- <h3 class="title-style">Registrati prima di accedere a Comunicazione Sicura</h3> -->
        <div class="md-subhead">
          {{ $t("message.welcome") }}
        </div>
      </md-card-header>

      <!--<md-card-content>-->
      <md-card-content>
        <h3>{{ $t("message.pinAccess") }}</h3>
        {{ $t("message.checkReceivedPin") }} {{ ph }}
        <!--{{ smsSent }} - {{ recaptchaSuccessful }} --- {{readyToLogin}}-->
        <form class="verify-pin-form" id="phone-auth" @submit.prevent="login">
          <input
            type="number"
            v-model="pin"
            class="simple-input"
            placeholder="PIN"
            data-parsley-required="true"
            data-parsley-type="digits"
            data-parsley-errors-messages-disabled="true"
          /><br />
          <md-button
            id="sign-in-button"
            class="md-raised md-accent"
            :md-ripple="false"
            @click="login($event)"
            onloadedmetadata=""
            >{{ $t("message.enter") }}</md-button
          >
        </form>
      </md-card-content>
      <!-- 
          <md-card-content v-if="!readyToLogin">
        Per accedere risolvi prima il Captcha
        <div id="recaptcha-container" align="center" />
      </md-card-content>
        
      -->

      <br />
      <p></p>
      <!--<a
        class="text-style"
        href="https://www.humanitas.it/info/info-contatti"
        style="color: #027953;"
        target="_blank"
        >Non riesci ad accedere?</a
      >
      <br /><br />-->
    </md-card>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import parsley from "parsleyjs";
import $ from "jquery";
import axios from "axios";
import languagePicker from "../components/language-picker/LanguagePicker.vue";

var init = true;

export default {
  name: "login",
  data() {
    return {
      pin: "",
      //phoneNumber: '+393404511702', // sq8
      //phoneNumber: '+393427415728', // G
      phoneNumber: "+393460378615", // JB
      ph: "",
      recaptchaVerifier: {},
      confirmationResult: {},
      recaptchaSuccessful: false,
      smsSent: false,
      verifyPinForm: {},
      attempts: 0,
      maxAttempts: 5
    };
  },
  computed: {
    readyToLogin: function() {
      return this.recaptchaSuccessful; // && this.smsSent;
    }
  },
  mounted: function() {
    //console.log("mounted");
    var self = this;
    self.ph =
      self.$store.state.prefix +
      " *******" +
      self.$store.state.detailPhone.substr(-3);
    //console.log(self.$store.state.detailPhone);

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    self.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: function(response) {
          //console.log("recaptcha");
          self.recaptchaSuccessful = true;
          // TODO: Hide recaptchca + show form pin
        },
        "expired-callback": function() {
          // Response expired. Ask user to solve reCAPTCHA again.
          // ...
          //console.log("expired");
        }
      }
    );
    firebase
      .auth()
      .signInWithPhoneNumber(
        self.$store.state.detailPhone,
        self.recaptchaVerifier
      )
      .then(function(confirmationResult) {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        //console.log("sms sent");
        self.confirmationResult = confirmationResult;
        self.smsSent = true;
      })
      .catch(function(error) {
        // Error; SMS not sent
        // ...
        //console.log(error);
        //console.log(error.code);
        if (error.code == "auth/too-many-requests") {
          self.$notify({
            group: "foo",
            title: self.$t("message.troppeRich"),
            text: self.$t("message.troppeRichMsg"),
            duration: 10000,
            closeOnClick: true,
            max: 1
          });
          setTimeout(() => {
            self.$router.push(self.$store.state.userFlux);
          }, 10000);
        } else {
          self.$notify({
            group: "foo",
            title: self.$t("message.smsProblem"),
            text: self.$t("message.smsProblemMsg"),
            duration: 10000,
            closeOnClick: true,
            max: 1
          });
        }
        //console.log("sms error");
      });
    //self.recaptchaVerifier.render()
  },
  methods: {
    login: function(e) {
      //console.log("login");
      var self = this;
      e.preventDefault();
      self.validatePin();

      self.attempts = self.attempts + 1;
    },
    validatePin: function() {
      var self = this;
      //console.log("stai in validate Pin");
      self.confirmationResult
        .confirm(self.pin)
        .then(function(result) {
          // User signed in successfully.
          var user = result.user;
          //console.log(user);
          //console.log(self.$store.state.redirectPath);
          self.$router.push(self.$store.state.redirectPath);
          // ...
        })
        .catch(function(error) {
          if (self.maxAttempts - self.attempts == 0) {
            axios
              .post(
                "/api/logging",
                {
                  component: "PAZIENTE",
                  event: "Superato numero tentativi login falliti",
                  description: self.$store.state.detailPhone
                },
                {
                  headers: {
                    //Authorization: 'Bearer ' + idToken
                  }
                }
              )
              .then(function(data) {
                //console.log("SUCCESS!!");
              })
              .catch(function() {
                //console.log("FAILURE!!");
              });
            self.$router.push(self.$store.state.userFlux);
          }

          axios
            .post(
              "/api/logging",
              {
                component: "PAZIENTE",
                event: "Tentativo login fallito",
                description: self.$store.state.detailPhone
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
          self.$notify({
            group: "foo",
            title: self.$t("message.wrongPin"),
            text:
              self.$t("message.wrongPinMsg1") +
              " " +
              (self.maxAttempts - self.attempts),
            duration: 10000,
            closeOnClick: true,
            max: 1
          });
          //console.log(error);
        });
    }
  },
  components: {
    languagePicker
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.simple-input {
  width: 40%;
  box-shadow: rgb(136, 136, 136) 3px 3px 3px !important;
  border: 0.1px solid lightgrey !important;
}

.login {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}

p {
  margin-top: 40px;
  font-size: 13px;
}

p a {
  text-decoration: underline;
  cursor: pointer;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

@media only screen and (max-width: 600px) {
  .md-card {
    width: 90%;
  }
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.home-button {
  width: 487px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.first-nav {
  background-color: #ffffff !important;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.user-mail-text {
  float: right;
  padding-top: 3%;
}

.person-icon {
  color: #027953;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}

.icon-style {
  font-size: 50px;
  background-color: #ea5b0c;
  color: #027953;
  border-radius: 22px;
  -webkit-border-radius: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/PhoneAuth.vue